import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { IHomeAddress } from '~/utils/interface/setup';

const urlApiSenior = 'seniors/profile';
const urlApiFunctionPermissions = 'seniors/function-permissions';

export interface IFunctionPermissionItem {
  functionKey: string;
  isEnabled: boolean;
  // false: the senior's Cognitive Decline Level doesn't allow this function at all
  isAvailableForLevel: boolean;
}

export interface IFunctionPermissions {
  useDefaultSettings: boolean;
  cognitiveDeclineLevel: number;
  permissions: IFunctionPermissionItem[];
}

// Everything GET /seniors/profile returns that the web edits (besides `profile`).
export interface ISeniorProfileResponse {
  profile: ISeniorProfile;
  languageCode?: string;
  languageVoiceCode?: string;
  navigationLanguageCode?: string;
  cognitiveDeclineLevel?: number;
  timezone?: string;
  // Senior Settings (screenTimeout / inactivityTimeout / flashlightTimeout are in seconds)
  brightness?: number;
  volume?: number;
  blockUnknownNumber?: boolean;
  themeMode?: string;
  flashlightOn?: boolean;
  flashlightTimeout?: number;
  screenTimeout?: number;
  inactivityTimeout?: number;
  fallDetectSensitivity?: number;
  thresholdLowBattery?: number;
  autoAnswerDelaySeconds?: number;
  dataRetentionDays?: number;
}

export interface ISeniorProfile {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  medicalHistory?: string | null;
  homeAddress?: IHomeAddress | null;
  avatarImage?: string | null;
}

const seniorApi = {
  getFunctionPermissions() {
    return axiosClient.get<IBaseResponse<IFunctionPermissions>>(urlApiFunctionPermissions);
  },
  // `overrides` only matters (and is only sent) when not using the default setting
  updateFunctionPermissions(body: { useDefaultSettings: boolean; overrides?: { functionKey: string; isEnabled: boolean }[] }) {
    return axiosClient.put<IBaseResponse<unknown>>(urlApiFunctionPermissions, body);
  },
  getProfile() {
    return axiosClient.get<IBaseResponse<ISeniorProfileResponse>>(urlApiSenior);
  },
  // multipart even without an avatar: the route's Joi expects homeAddress as a JSON string
  updateProfile(body: FormData) {
    return axiosClient.put<IBaseResponse<unknown>>(urlApiSenior, body, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export default seniorApi;
